import { css as t } from "@microsoft/fast-element";
import { display as r } from "@matrix42/fast-foundation";
import { normalize as i } from "../../common/normalize.js";
import { designTokens as o } from "../../design-tokens.js";
import { typography as n } from "../../styles/typography.js";
const l = t`
  ${i}
  ${r("flex")}
  :host {
    /* Base */
    cursor: pointer;
    user-select: none;
    /* Layout */
    padding: ${o.spacing[2]} ${o.spacing[4]};
    justify-content: center;
    align-items: center;
    gap: ${o.spacing["2.5"]};
    /* Styles */
    text-align: center;
    color: ${o.color.neutral[500]};
    border-bottom: ${o.borderWidth.sm} solid transparent !important;
    /* Transitions */
    transition: border-color ${o.transition.fast},
      color ${o.transition.fast},
      padding ${o.transition.fast};
    /* Typography */
    ${n("p", "semibold")}
  }

  :host([aria-selected='true']) {
    /* Layout */
    padding-left: ${o.spacing[8]};
    padding-right: ${o.spacing[8]};
    /* Styles */
    color: ${o.color.primary[100]};
    border-bottom-color: ${o.color.primary[90]} !important;
  }
`;
export {
  l as tabStyles
};
